jQuery(document).ready(function() {

  jQuery('#btn-back').on('click', function() {

    window.history.go(-1); 

    return false;

  });

});

jQuery.extend(jQuery.easing, {
	easeInOutCubic: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t*t + b;
		return c/2*((t-=2)*t*t + 2) + b;
	}
});

jQuery(document).ready(function(){
  var container = jQuery('.progressbar');
  var shim = jQuery('.progressbar .shim');
  var holder = jQuery('.progressbar .holder');
  var bar = jQuery('.progressbar .bar');
  var indicator = jQuery('.progressbar .indicator');
  var labels = jQuery('.progressbar .labels');
  console.log("HI");
  
  jQuery('.history-container h2.t-year').each(function(){
    var code = '<i data-label="'+jQuery(this).text()+'"></i>';
    labels.append(code);
  });
  
});